import PropTypes from 'prop-types';
import map from 'lodash/map';

import FavoriteOption from '../../../shared/FavoriteOption';
import withOutsideClickControl from '../../../../decorators/withOutsideClickControl';
import FavoriteIcon from './FavoriteIcon';
import FavoriteOptionSelector from './FavoriteOptionSelector';
import FavoriteIconControl from './FavoriteIconControl';
import FavoriteStyleContext from './context/FavoriteStyleContext';

import css from './favorite-control-with-options.module.scss';

export function FavoriteControlWithOptions({
  tunedGuideId,
  isFollowing,
  followOptions,
  isMobile,
  containerProps,
  handleOnClick,
  isOpen,
}) {
  const wrapperProps = {
    className: css.container,
    'data-testid': 'favoriteControlWithOptionsContainer',
    ...containerProps,
  };

  return (
    <div {...wrapperProps}>
      <FavoriteOptionSelector
        isOpen={isOpen}
        onClose={() => handleOnClick(false)}
        popoverClassName={css.popover}
        dialogBodyClassName={css.dialogBody}
        dialogContentClassName={css.dialogContent}
        closeIconAttributes={{ className: css.closeIcon }}
        isMobile={isMobile}
      >
        <div className={css.content}>
          <div data-testid="follow-options-header" className={css.header}>
            Options
          </div>
          <FavoriteStyleContext.Provider
            value={{ iconClassName: css.favoriteIcon }}
          >
            {map(followOptions, (followOption) => {
              const { title, guideId } = followOption;
              return (
                <FavoriteOption
                  actionOrFollowOption={followOption}
                  title={title}
                  guideId={guideId}
                  key={guideId}
                />
              );
            })}
          </FavoriteStyleContext.Provider>
        </div>
      </FavoriteOptionSelector>
      <FavoriteIconControl
        guideId={tunedGuideId}
        isFollowing={isFollowing}
        isOptionsController
      >
        {(props) => <FavoriteIcon {...props} onClick={handleOnClick} />}
      </FavoriteIconControl>
    </div>
  );
}

FavoriteControlWithOptions.propTypes = {
  tunedGuideId: PropTypes.string.isRequired,
  followOptions: PropTypes.object.isRequired,
  isFollowing: PropTypes.bool.isRequired,
  isMobile: PropTypes.bool.isRequired,
  handleOnClick: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  containerProps: PropTypes.object.isRequired,
};

export default withOutsideClickControl(FavoriteControlWithOptions);
